import { WizardStepContentProps } from 'features/wizard/models/WizardStepContentProps';
import useMarketDrivenShippingStatus from 'hooks/useMarketDrivenShippingStatus';
import { MarketRateStep } from './MarketRateStep';
import { ShippingZoneRateStep } from './ShippingZoneRateStep';

/**
 * The wizard's `shipping_zone_rate` step, split by market-driven-shipping status: `ShippingZoneRateStep`
 * (zone-based, `useZonesWithMappedProviders`) for a shop still on LEGACY shipping, `MarketRateStep`
 * (per-provider country/rate mapping, `useProviderRateMappingData`) once market-driven shipping is
 * active — same split as the Shipping/PickupPoint provider-settings sections.
 */
export const ShippingRateStep: React.FC<WizardStepContentProps> = ({ onLoadingChange }) => {
    const { isLegacy } = useMarketDrivenShippingStatus();

    return isLegacy ? (
        <ShippingZoneRateStep onLoadingChange={onLoadingChange} />
    ) : (
        <MarketRateStep onLoadingChange={onLoadingChange} />
    );
};
